import * as React from "react";
import { BannerContainer } from "../../../components/BannerContainer";
import { LinkTargetType } from "../../../services/playground";
import { MagicLinkBox } from "./styles";
const MMagicBanner = (props) => {
    const { banner, positionId, linkItems, style = { width: "100%" }, className, placeholderBg, aTarget = LinkTargetType.Blank } = props;
    const bannerHeight = banner.height || "auto";
    return (React.createElement(BannerContainer, { banner: banner, "data-id": positionId, id: positionId, className: className || "", keepSize: true, placeholderBg: placeholderBg, gridHeight: bannerHeight, style: Object.assign({}, style) }, (linkItems || []).map((item, i) => (React.createElement(MagicLinkBox, { key: i, href: item.link, onClick: () => props.onClick && props.onClick(item.link), target: item.link.startsWith("#") ? "_self" : aTarget, style: {
            width: `${Math.min(100, +(item.width || 0))}%`,
            height: `${item.height}%`,
            top: `${item.top}%`,
            left: `${item.left}%`,
        } })))));
};
export default MMagicBanner;
